import { render, staticRenderFns } from "./SearchColumnsControl.vue?vue&type=template&id=2640c16b&scoped=true&"
import script from "./SearchColumnsControl.vue?vue&type=script&lang=js&"
export * from "./SearchColumnsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2640c16b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
